<template>
  <div
    class="teacherParent"
    v-lazy:background-image="{
      src: bg,
    }"
  >
    <div class="divCourseStudy">
      <div class="divStudy" @click="qimoChatClick">马上学习</div>
    </div>
    <title-widge :title="title" :subTitle="subTitle"></title-widge>
    <div class="divContent">
      <div
        class="item"
        v-for="(item, index) in items"
        :key="index"
        @click="activeIndex = index"
      >
        <div class="divImg" :class="{ divItemActive: activeIndex === index }">
          <img v-lazy="item.url" />
        </div>
        <div class="divTitle">{{ item.title }}</div>
        <div class="divSubTitle">{{ item.subTitle }}</div>
        <div class="divContainer" v-show="activeIndex === index">
          <div class="divTitle">讲师简介</div>
          <div class="divDesc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    bg: {
      //背景图
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  watch: {},
  methods: {
    qimoChatClick() {
      this.$trackEvent("马上学习", "点击")
      window.qimoChatClick();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/teacherDisplayWidge.scss";
</style>
